import { StaticImage } from 'gatsby-plugin-image'
import React, { useRef } from 'react'
import * as ProductIcons from 'components/ProductIcons'
import * as NotProductIcons from 'components/NotProductIcons'
import { useInView } from 'react-intersection-observer'
import Logo from 'components/Logo'

const Customer = ({ icon: image, width, height, className = '' }) => {
    const Icon = NotProductIcons[image] || ProductIcons[image]
    return (
        <li
            className="border-t border-l border-dashed border-gray-accent-light flex items-center  justify-center
            h-24
            py-6
            w-full
            lg:px-2
            lg:h-40
        "
        >
        {Icon && <Icon className={`icon px-4 md:px-6 lg:px-4 ${className}`} />}
            {/* <img className={`icon px-4 md:px-6 lg:px-4 ${className}`} width={width} height={height} src={image} /> */}
        </li>
    )
}

export default function Customers({ allCustomers, googleImages })  {
    const { title,  img, logo, customers,enable } = allCustomers
       if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }
    const googleImage = img && googleImages && googleImages[0] && googleImages[0].filter((image) => { if (image.name == img) return image })[0]
    const googleImage2 = img && googleImages && googleImages[1] && googleImages[1].filter((image) => { if (image.name == img) return image })[0]
    const gatsbyImage = googleImage && getImage(googleImage)
    const gatsbyImage2 = googleImage2 && getImage(googleImage2)
    const { ref, inView, entry } = useInView({ triggerOnce: true })
    return (
        <section className="mb-16 -mt-[1px]">
            <div className="bg-almost-black py-8 md:py-12 xl:py-16 px-4 relative z-20">
                <h2 className="m-0 text-center text-4xl lg:text-5xl 2xl:text-6xl text-white max-w-screen-2xl mx-auto"
                dangerouslySetInnerHTML={{ __html: title }}>
                </h2>
                <Logo className="inline-flex ml-4 -mt-2 h-8 lg:h-10 xl:h-12 2xl:h-14 color=white fill-current" />
                {/* <Logo className="max-w-[25px] sm:max-w-[40px] md:w-auto" color="white" noText /> */}
            </div>
            <div className="mt-8 max-w-screen-2xl mx-auto px-4 2xl:px-0 flex items-center sm:items-end flex-col sm:flex-row">
                <ul className="list-none m-0 p-0 grid grid-cols-2 md:grid-cols-2 border-b border-r border-dashed border-gray-accent-light flex-grow w-full">
                {customers.map((customer) => (
                        <Customer key={customer.icon} icon={customer.icon} className={customer.className} />
                    ))}
                </ul>
            </div>
        </section>
    )
}
